import React, { useEffect, useState } from "react";
import SidebarContext from "./SidebarContext";
function SidebarState(props) {
    const [menutoggle, setMenutoggle] = useState(false);
    const [logoutDropdownactive, setlogoutDropdownactive] = useState(false);
    const [alert, setAlert] = useState({
        fade: "fade-default",
        msg: "",
        type: "",
    });
    const [logoutdata, setLogout] = useState(false);
    const [resetPassword, setresetPassword] = useState(false);
    const [msg, setMsg] = useState({});

    const url = process.env.REACT_APP_URL
    const userinfo = JSON.parse(localStorage.getItem("userInfo"));

    return (
        <SidebarContext.Provider
            value={{
                menutoggle,
                setMenutoggle,
                logoutDropdownactive,
                setlogoutDropdownactive,
                alert,
                setAlert,
                logoutdata,
                setLogout,
                resetPassword,
                setresetPassword,
                msg,
                setMsg,
                url,
                userinfo
            }}
        >
            {props.children}
        </SidebarContext.Provider>
    );
}

export default SidebarState;
